export default "__VITE_ASSET__wRxTXK3j__"